<template>
  <Modal
    :id="'cmp-catalog-statement-advanced_search'"
    :loading="loading"
    @cancelled="onCancel"
  >
    <template slot="header">{{
      $dft.snakeCaseToWords("advanced_search")
    }}</template>

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <Dropdown
            :id="'label_status_ids'"
            class="m2"
            :options="advancedSearchData.labelStatusTV"
            :selected="label_status_idsTV"
            :placeholder="'Status'"
            box
            deselect
            multiple
            @selectedChange="(e) => onDropdownChange('label_status_ids', e)"
          ></Dropdown>
          <Dropdown
            :id="'invoice_project_ids'"
            class="m2"
            :options="advancedSearchData.invoiceProjectTV"
            :selected="invoice_project_idsTV
            "
            :placeholder="$t('invoice_project')"
            box
            multiple
            deselect
            @selectedChange="(e) => onDropdownChange('invoice_project_ids', e)"
          ></Dropdown>
          <Dropdown
            :id="'period_type'"
            class="m2"
            :options="advancedSearchData.periodTypeTV"
            :selected="
              advancedSearchData.periodTypeTV.find(
                (x) => x.value == period_type
              )
            "
            :placeholder="'Period Type'"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('period_type', e)"
          ></Dropdown>
           <Dropdown
           :id="royalty_account_id"
                :options="advancedSearchData.royaltyAccountTV"
                :placeholder="'Royalty Account'"
                 box
                isSearchable
                class="search-container-dropdown m2"
                deselect
               
                v-on:selectedChange="
                  (e) => onDropdownChange('royalty_account_id',e)
                "
                :selected="
              advancedSearchData.royaltyAccountTV.find(
                (x) => x.value == royalty_account_id
              )
            "
                @searched="onRoyaltyAccountSearch"
          ></Dropdown>
          <Dropdown
            :id="'year'"
            class="m2"
            :options="advancedSearchData.yearTV"
            :selected="yearSelectedTV
            "
            :placeholder="'Year'"
            box
            multiple
            deselect
            @selectedChange="(e) => onDropdownChange('year', e)"
          ></Dropdown>

          <Dropdown
            :id="'periods'"
            class="m2"
            :options="advancedSearchData.periodTV"
            :selected="
             periodsSelectedTV
            "
            :placeholder="'Periods'"
            box
            deselect
            multiple
            @selectedChange="(e) => onDropdownChange('periods', e)"
          ></Dropdown>
  
          <div class="ut-flex" style="gap:10px;max-width: 358px;">
            <TextField
          style="flex:1;"
          class="m1"
          :id="'amount_start'"
          v-bind="textFieldConfig"
          :value="amount_start"
          :placeholder="'Amount From'"
          @valuechanged="onTextFieldValueChange"
         
        />
        <TextField
          style="flex:1;"
          class="m1"
          :id="'amount_end'"
          v-bind="textFieldConfig"
          :value="amount_end"
          :placeholder="'Amount Until'"
          @valuechanged="onTextFieldValueChange"
         
        />


      </div>
      <Dropdown
        :id="'release_id'"
        class="search-container-dropdown m2"
        :options="advancedSearchData.releasesTV || []"
        :placeholder="$t('releases')"
        isSearchable
        deselect
        box
        @selectedChange="(e) => onAutocompleteSelected('release_id', e)"
        :selected="advancedSearchData.releasesTV.find((t) => t.value == release_id)"
        @searched="
          (e) =>
            onDropdownSearch(e, 'search_releases', {
              tvArray: 'releases',
              tvText: 'release_artist',
              tvValue: 'release_id',
            })
        "
      >
      </Dropdown>
          <div class="ut-flex" style="gap:10px;max-width: 358px;">
            <TextField
          style="flex:1;"
          class="m1"
          :type="'date'"
          :id="'start'"
          v-bind="textFieldConfig"
          :value="start"
          :placeholder="'From'"
          @valuechanged="onTextFieldValueChange"
         
        />
        <TextField
          style="flex:1;"
          class="m1"
          :type="'date'"
          :id="'end'"
          v-bind="textFieldConfig"
          :value="end"
          :placeholder="'Until'"
          @valuechanged="onTextFieldValueChange"
         
        />


      </div>
      <Dropdown
            :id="'locked'"
            class="m2"
            :options="advancedSearchData.lockedTV"
            :selected="
              advancedSearchData.lockedTV.find(
                (x) => x.value == locked
              )
            "
            :placeholder="'Locked'"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('locked', e)"
          ></Dropdown>
          <Dropdown
            :id="'send_out'"
            class="m2"
            :options="advancedSearchData.sendOutTV"
            :selected="
              advancedSearchData.sendOutTV.find(
                (x) => x.value == send_out
              )
            "
            :placeholder="'Send Out Type'"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('send_out', e)"
          ></Dropdown>
          <!-- <TextField
          style="flex:1;"
          class="m1"
          :id="'pdf'"
          v-bind="textFieldConfig"
          :value="pdf"
          :placeholder="'Pdf'"
          @valuechanged="onTextFieldValueChange"
         
        /> -->

        </div>
      </div>
    </template>

    <template slot="options">

      <button class="dt-button s6" @click.stop="onCancel">Close</button>
      <button
        class="dt-button v1 s6"
        @click.stop="onSearch"
        :disabled="this.isFilterEmpty()"
        :class="{
          disabled: this.isFilterEmpty(),
        }"
        :title="this.isFilterEmpty() ? filterEmptyError() : ''"
      >
        Search
      </button>
    </template>
  </Modal>
</template>

<script>
import FileDownload from "js-file-download";
import Modal from "@dtplugins/modal/modal";
import TextField from "@plugins/text-field/text-field";
import { createTV } from "../../../../models/text-value.model";
import {
  ensureBoolIntObjectFromKeys,
  ensureStringObject,
  ensureStringObjectFromKeys,
  keyValuesToObj,
} from "../../../../utility/fp";
import { createAdvancedSearchModal } from "../../../../dt-plugins/advanced-search/advance-search.mixin";
import { createAdvancedSearchConfig } from "../../../../dt-plugins/advanced-search/advanced-search.model";

export const statementListDefaultAdvancedSearchConfig = createAdvancedSearchConfig({
  searchConfigStringKeys: [
    "royalty_account_id",
    "label_status_ids",
    "periods",
    "invoice_project_ids",
    'period_type',
    'amount_end',
    'amount_start',
    'start',
    'end',
    'year',
    'release_id',
    'locked',
    'send_out',
    'pdf',
  ],
  searchConfigIntKeys: [
    
  ],
  booleanSearchKeyLabelMap: {
  },
  searchConfigMulTVMap: [
    ["label_status_ids", "labelStatusTV"],
    ["periods", "periodTV"],
    ["invoice_project_ids", "invoiceProjectTV"],
    ['year','yearTV'],],
  searchConfigTVMap: [
    ["royalty_account_id", "royaltyAccountTV"],
    ['period_type','periodTypeTV'],
    ['release_id','releasesTV'],
    ['send_out','sendOutTV'],
    ['locked','lockedTV'],
  
  ],
  searchConfigOmitKeyMap: [
    
  ],
});

export default {
  components: {
    Modal,
    TextField,
  },
  //props:["advancedSearchData"],
  data() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        isModel: true,
      },
      
      royalty_account_id:"",
      deal_id:"",
      periods:"",
      royalty_period:"",  
      invoice_project_ids:"",  
      label_status_ids:"", 
      loading: false,
      period_type:'',
      amount_start:'',
      amount_end:"",
      start:'',
      end:'',
      release_id:"",
      locked:'',
      send_out:"",
      pdf:'',
      year:""
    };
  },
  mixins: [createAdvancedSearchModal(statementListDefaultAdvancedSearchConfig)],
  computed: {
    label_status_idsTV(){
      const label_status_idsArr = this.label_status_ids?.split(',') || [];
      return this.advancedSearchData.labelStatusTV.filter( s => label_status_idsArr.includes("" + s.value) ) || [];
    },
    periodsSelectedTV(){
      const periodsArr = this.periods?.split(',') || [];
      return this.advancedSearchData.periodTV.filter( s => periodsArr.includes("" + s.value) ) || [];
    },
    yearSelectedTV(){
      const yearArr = this.year?.split(',') || [];
      return this.advancedSearchData.yearTV.filter( s => yearArr.includes("" + s.value) ) || [];
    },
    invoice_project_idsTV(){
      const invoice_project_idsArr = this.invoice_project_ids?.split(',') || [];
      return this.advancedSearchData.invoiceProjectTV.filter( s => invoice_project_idsArr.includes("" + s.value) ) || [];
    },
    searchFilter: function () {
      return {
        ...ensureStringObjectFromKeys(
          this,
          statementListDefaultAdvancedSearchConfig.searchConfigStringKeys
        ),
        ...ensureBoolIntObjectFromKeys(
          this,
          statementListDefaultAdvancedSearchConfig.booleanSearchKeys
        ),
        ...ensureBoolIntObjectFromKeys(
          this,
          statementListDefaultAdvancedSearchConfig.searchConfigIntKeys
        ),
      };
    },
  },
  methods: {


    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onDropdownChange: function (name, value) {
      let val = value.value;
      if(['invoice_project_ids', 'label_status_ids','year','periods'].includes(name)){
        val = value.map(r => r.value).join();
      }
      this[name] =val;
    },


    onSearch: async function () {
      console.log('this.searchFilter',this.searchFilter)
      this.$emit("search", this.searchFilter);
    },

    onSearchOmittedToggle: function (name) {
      if (this[`${name}_missing`] == 1) {
        this[`${name}_missing`] = "0";
      } else {
        this[`${name}_missing`] = `1`;
      }
    },
    isOmitted(name) {
      return this[`${name}_missing`] == `1`;
    },
    filterEmptyError() {
      return `Please provide value to any one of these Fields - Artist, Title, Version, Track type, Digital right, Genres, Isrc error, Missing main product, Product track mismatch, Licence account, Main label, Any label, Royalty account, No contract, Playtime missing, Composer missing, Composer, Writer missing, Writer, Publisher missing, Publisher, Producer missing, Producer, Arranger missing, Arranger, Metadata value1, Metadata value2, Metadata value3, Track grid`;
    },
    isFilterEmpty() {
      let {
       royalty_account_id,
       periods,
       royalty_period,
       invoice_project_ids,
       label_status_ids,
       period_type,
       amount_start,
       amount_end,
       start,
       end,
       release_id,
       locked,
       send_out,
       pdf,year

      } = this;

      if (
       !royalty_account_id &&
       !periods &&
       !royalty_period &&
       !invoice_project_ids &&
       !label_status_ids &&
       !period_type&&
       !amount_start&&
       !amount_end&&
       !start&&
       !end&&
       !release_id&&
       !locked&&
       !send_out&&
       !pdf&&
       !year

      ) {
        return true;
      }
      return false;
    },

    //searchable dropdown
    onRoyaltyAccountSearch:function(searchTerm){
      console.log("Search works",searchTerm)
        this.$emit("autoCompleteSearch",{searchTerm:searchTerm ,action:"search_accounts"});
    },
    onDealTypeSearch:function(searchTerm){
        this.$emit("autoCompleteSearch",{searchTerm:searchTerm ,action:"search_id_prods"});
    },
    onAutocompleteSelected:function(name,e){
      console.log("item,e",e);
      this[name]=e.value;
    },
    onDropdownSearch: async function (e, name, tvInfo) {
      this.$emit("searchDropDown", { e, name, tvInfo , label_id:this.label_id});
    },

    onTextFieldValueChange: function (name, value) {    
      this[name]=value;
    },

  },
};
</script>

<style lang="scss" scoped>
.cmp-catalog-statement-advanced_search {
  .body-container {
    max-height: 470px;
    padding-right: 15px;
    overflow: hidden;
    overflow-y: auto;

    .dropdown,
    .dt-input-box--container,
    .date-control {
      max-width: 358px;
    }
  }
  .omit-toggler {
    display: flex;
    cursor: pointer;

    &.missed {
      color: var(--c-error);
    }

    .omit-toggler--label {
      margin: auto 0px auto 4px;
      cursor: pointer;
    }
  }

  .search--input {
    flex: 1;
  }

  .search--checkbox {
    min-width: 20px;
    margin-left: 4px;

    display: flex;
    flex-direction: column;
    justify-content: center;

    @media screen and (min-width: 320px) and (max-width: 480px) {
      padding-left: 0px;
      margin-left: 0px;

      .checkmark {
        margin-left: 10px;
      }
    }
  }

  .checkbox-container {
    .dt-checkbox-control {
      align-items: center;
      .dt-checkbox-label {
        flex: 1;
        padding-left: 10px;
      }
    }
  }

  .row-control {
    margin: 10px 0;
    .search--input {
      max-width: 100%;
    }
  }
  .date-control {
    .dt-input-box--container {
      flex: 1;
      &:first-child {
        padding-right: 10px;
      }
      &:last-child {
        padding-left: 10px;
      }
    }
  }


}
</style>